<div class="dd-page">

  <!-- ============================================================
       HERO SECTION
       ============================================================ -->
  <section class="dd-hero">

    <div class="dd-hero-blob dd-hero-blob--1"></div>
    <div class="dd-hero-blob dd-hero-blob--2"></div>
    <div class="dd-hero-blob dd-hero-blob--3"></div>

    <div class="dd-container">

      <div class="dd-hero-content">

        <div class="dd-hero-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2L15 8L22 9L17 14L18 22L12 19L6 22L7 14L2 9L9 8L12 2Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round">
            </path>
          </svg>

          Premium Digital Downloads
        </div>

        <h1 class="dd-hero-title">
          Download Premium
          <span>11+ Resources</span>
        </h1>

        <p class="dd-hero-subtitle">
          Professionally designed practice papers, mock exams,
          revision guides and preparation packs created by
          experienced 11+ tutors.
        </p>

        <div class="dd-hero-features">

          <div class="dd-feature-pill">
            Instant Access
          </div>

          <div class="dd-feature-pill">
            Lifetime Download
          </div>

          <div class="dd-feature-pill">
            Expert Created
          </div>

          <div class="dd-feature-pill">
            Printable PDFs
          </div>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       BENEFITS STRIP
       ============================================================ -->
  <section class="dd-benefits-strip">

    <div class="dd-container">

      <div class="dd-benefits-grid">

        <div class="dd-benefit-item">
          <div class="dd-benefit-icon">

            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
                stroke="currentColor"
                stroke-width="2">
              </path>

              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                stroke-width="2">
              </path>

              <path
                d="M12 15V3"
                stroke="currentColor"
                stroke-width="2">
              </path>

            </svg>

          </div>

          <div>
            <h4>Instant Download</h4>
            <p>Get access immediately after payment</p>
          </div>
        </div>

        <div class="dd-benefit-item">
          <div class="dd-benefit-icon">

            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 1V23"
                stroke="currentColor"
                stroke-width="2">
              </path>

              <path
                d="M17 5H9.5C8.12 5 7 6.12 7 7.5C7 8.88 8.12 10 9.5 10H14.5C15.88 10 17 11.12 17 12.5C17 13.88 15.88 15 14.5 15H7"
                stroke="currentColor"
                stroke-width="2">
              </path>

            </svg>

          </div>

          <div>
            <h4>One-Time Payment</h4>
            <p>No subscriptions or recurring charges</p>
          </div>
        </div>

        <div class="dd-benefit-item">
          <div class="dd-benefit-icon">

            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 12L11 14L15 10"
                stroke="currentColor"
                stroke-width="2">
              </path>

              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="2">
              </circle>

            </svg>

          </div>

          <div>
            <h4>Exam Focused</h4>
            <p>Aligned to current 11+ exam formats</p>
          </div>
        </div>

        <div class="dd-benefit-item">
          <div class="dd-benefit-icon">

            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
                stroke="currentColor"
                stroke-width="2">
              </path>

            </svg>

          </div>

          <div>
            <h4>Secure Purchase</h4>
            <p>Protected payments and lifetime access</p>
          </div>
        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       SEARCH + FILTER SECTION
       ============================================================ -->
  <section class="dd-search-section">

    <div class="dd-container">

      <div class="dd-search-card">

        <div class="dd-search-wrapper">

          <svg
            class="dd-search-icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none">

            <circle
              cx="11"
              cy="11"
              r="7"
              stroke="currentColor"
              stroke-width="2">
            </circle>

            <path
              d="M21 21L16.65 16.65"
              stroke="currentColor"
              stroke-width="2">
            </path>

          </svg>

          <input
            type="text"
            class="dd-search-input"
            placeholder="Search premium resources..."
            [(ngModel)]="searchQuery"
            (input)="filterResources()">

        </div>

        <div class="dd-filter-pills">

          <button
            *ngFor="let cat of categories"
            class="dd-filter-pill"
            [class.dd-filter-pill--active]="activeCategory === cat"
            (click)="setCategory(cat)">

            {{ cat }}

          </button>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       STATS STRIP
       ============================================================ -->
  <section class="dd-stats">

    <div class="dd-container">

      <div class="dd-stats-grid">

        <div class="dd-stat-card">

          <div class="dd-stat-number">
            {{ resources.length }}+
          </div>

          <div class="dd-stat-label">
            Premium Resources
          </div>

        </div>

        <div class="dd-stat-card">

          <div class="dd-stat-number">
            15,000+
          </div>

          <div class="dd-stat-label">
            Downloads
          </div>

        </div>

        <div class="dd-stat-card">

          <div class="dd-stat-number">
            98%
          </div>

          <div class="dd-stat-label">
            Parent Satisfaction
          </div>

        </div>

        <div class="dd-stat-card">

          <div class="dd-stat-number">
            11+
          </div>

          <div class="dd-stat-label">
            Exam Specialists
          </div>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       RESULTS BAR
       ============================================================ -->
  <section class="dd-results-section">

    <div class="dd-container">

      <div class="dd-results-bar">

        <div class="dd-results-left">

          Showing
          <strong>
            {{ filteredResources.length }}
          </strong>

          resource{{ filteredResources.length !== 1 ? 's' : '' }}

          <span *ngIf="activeCategory !== 'All'">

            in

            <em>
              {{ activeCategory }}
            </em>

          </span>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       EMPTY STATE
       ============================================================ -->
  <section
    class="dd-empty-section"
    *ngIf="filteredResources.length === 0">

    <div class="dd-container">

      <div class="dd-empty">

        <div class="dd-empty-icon">

          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">

            <circle
              cx="11"
              cy="11"
              r="7"
              stroke="currentColor"
              stroke-width="2">
            </circle>

            <path
              d="M21 21L16.65 16.65"
              stroke="currentColor"
              stroke-width="2">
            </path>

          </svg>

        </div>

        <h3>
          No resources found
        </h3>

        <p>
          Try a different search term or category.
        </p>

        <button
          class="dd-reset-btn"
          (click)="resetFilters()">

          Clear Filters

        </button>

      </div>

    </div>

  </section>

  <!-- ============================================================
       RESOURCE GRID START
       ============================================================ -->
  <section
    class="dd-grid-section"
    *ngIf="filteredResources.length > 0">

    <div class="dd-container">

      <div class="dd-grid">

                <!-- ============================================================
             RESOURCE CARD
             ============================================================ -->
        <div
          class="dd-card"
          *ngFor="let res of filteredResources">

          <!-- Top Accent -->
          <div
            class="dd-card-accent"
            [ngClass]="'dd-card-accent--' + res.colorKey">
          </div>

          <!-- Sale Badge -->
          <div
            class="dd-sale-badge"
            *ngIf="res.salePrice && res.salePrice < res.price">

            Save {{ getDiscountPercentage(res.price, res.salePrice) }}%

          </div>

          <!-- Bestseller Badge -->
          <div
            class="dd-bestseller-badge"
            *ngIf="res.downloads > 500">

            Bestseller

          </div>

          <!-- Card Header -->
          <div class="dd-card-header">

            <div
              class="dd-card-icon"
              [ngClass]="'dd-card-icon--' + res.colorKey">

              <!-- Maths -->
              <svg
                *ngIf="res.icon === 'maths'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">

                <line
                  x1="18"
                  y1="20"
                  x2="18"
                  y2="10"
                  stroke="currentColor"
                  stroke-width="2">
                </line>

                <line
                  x1="12"
                  y1="20"
                  x2="12"
                  y2="4"
                  stroke="currentColor"
                  stroke-width="2">
                </line>

                <line
                  x1="6"
                  y1="20"
                  x2="6"
                  y2="14"
                  stroke="currentColor"
                  stroke-width="2">
                </line>

              </svg>

              <!-- English -->
              <svg
                *ngIf="res.icon === 'english'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">

                <path
                  d="M12 20H21"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

                <path
                  d="M16.5 3.5A2.121 2.121 0 0 1 19.5 6.5L7 19L3 20L4 16L16.5 3.5Z"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

              </svg>

              <!-- VR -->
              <svg
                *ngIf="res.icon === 'vr'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">

                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="2">
                </circle>

                <line
                  x1="12"
                  y1="8"
                  x2="12"
                  y2="12"
                  stroke="currentColor"
                  stroke-width="2">
                </line>

                <line
                  x1="12"
                  y1="16"
                  x2="12.01"
                  y2="16"
                  stroke="currentColor"
                  stroke-width="2">
                </line>

              </svg>

              <!-- NVR -->
              <svg
                *ngIf="res.icon === 'nvr'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">

                <rect
                  x="3"
                  y="3"
                  width="7"
                  height="7"
                  stroke="currentColor"
                  stroke-width="2">
                </rect>

                <rect
                  x="14"
                  y="3"
                  width="7"
                  height="7"
                  stroke="currentColor"
                  stroke-width="2">
                </rect>

                <rect
                  x="14"
                  y="14"
                  width="7"
                  height="7"
                  stroke="currentColor"
                  stroke-width="2">
                </rect>

                <rect
                  x="3"
                  y="14"
                  width="7"
                  height="7"
                  stroke="currentColor"
                  stroke-width="2">
                </rect>

              </svg>

              <!-- Guide -->
              <svg
                *ngIf="res.icon === 'guide'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">

                <path
                  d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

                <path
                  d="M6.5 2H20V22H6.5A2.5 2.5 0 0 1 4 19.5V4.5A2.5 2.5 0 0 1 6.5 2Z"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

              </svg>

              <!-- Paper -->
              <svg
                *ngIf="res.icon === 'paper'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">

                <path
                  d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2Z"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

                <polyline
                  points="14 2 14 8 20 8"
                  stroke="currentColor"
                  stroke-width="2">
                </polyline>

              </svg>

            </div>

            <div class="dd-card-tags">

              <span
                class="dd-tag"
                [ngClass]="'dd-tag--' + res.colorKey">

                {{ res.category }}

              </span>

              <span
                class="dd-tag dd-tag--outline"
                *ngIf="res.level">

                {{ res.level }}

              </span>

            </div>

          </div>

          <!-- Body -->
          <div class="dd-card-body">

            <h3 class="dd-card-title">
              {{ res.title }}
            </h3>

            <p class="dd-card-desc">
              {{ res.description }}
            </p>

            <div class="dd-card-meta">

              <div class="dd-meta-item">

                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none">

                  <path
                    d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2Z"
                    stroke="currentColor"
                    stroke-width="2">
                  </path>

                </svg>

                {{ res.fileType }} • {{ res.fileSize }}

              </div>

              <div class="dd-meta-item">

                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none">

                  <path
                    d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
                    stroke="currentColor"
                    stroke-width="2">
                  </path>

                </svg>

                {{ res.downloads }}
                downloads

              </div>

            </div>

          </div>

          <!-- Pricing -->
          <div class="dd-card-pricing">

            <div class="dd-price-wrap">

              <span
                class="dd-old-price"
                *ngIf="res.salePrice && res.salePrice < res.price">

                £{{ res.price }}

              </span>

              <span class="dd-current-price">

                £{{ res.salePrice || res.price }}

              </span>

            </div>

          </div>

          <!-- Footer -->
          <div class="dd-card-footer">

            <button
              class="dd-buy-btn"
              (click)="openPurchaseModal(res)">

              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none">

                <path
                  d="M12 2V22"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

                <path
                  d="M17 5H9.5A2.5 2.5 0 0 0 9.5 10H14.5A2.5 2.5 0 0 1 14.5 15H7"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

              </svg>

              Buy & Download

            </button>

          </div>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       PURCHASE MODAL
       ============================================================ -->
  <div
    class="dd-modal-overlay"
    *ngIf="showModal"
    (click)="closeModal()">

    <div
      class="dd-modal"
      (click)="$event.stopPropagation()">

      <!-- Close -->
      <button
        class="dd-modal-close"
        (click)="closeModal()">

        ✕
      </button>

      <!-- Tabs -->
      <div
        class="dd-modal-tabs"
        *ngIf="!paymentCompleted">

        <button
          [class.active]="activeTab === 'purchase'"
          (click)="activeTab = 'purchase'">

          Purchase

        </button>

        <button
          [class.active]="activeTab === 'existing'"
          (click)="activeTab = 'existing'">

          Already Purchased

        </button>

      </div>

            <!-- ============================================================
           PURCHASE TAB
           ============================================================ -->
      <div
        class="dd-modal-content"
        *ngIf="activeTab === 'purchase' && !paymentCompleted">

        <!-- LEFT SIDE -->
        <div class="dd-modal-left">

          <div class="dd-product-card">

            <div
              class="dd-product-icon"
              [ngClass]="'dd-card-icon--' + (selectedResource?.colorKey || 'navy')">

              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none">

                <path
                  d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2Z"
                  stroke="currentColor"
                  stroke-width="2">
                </path>

                <polyline
                  points="14 2 14 8 20 8"
                  stroke="currentColor"
                  stroke-width="2">
                </polyline>

              </svg>

            </div>

            <div class="dd-product-info">

              <div
                class="dd-product-category">

                {{ selectedResource?.category }}

              </div>

              <h2 class="dd-product-title">

                {{ selectedResource?.title }}

              </h2>

              <p class="dd-product-desc">

                {{ selectedResource?.description }}

              </p>

            </div>

            <div class="dd-product-details">

              <div class="dd-product-detail">

                <span>Format</span>

                <strong>
                  {{ selectedResource?.fileType }}
                </strong>

              </div>

              <div class="dd-product-detail">

                <span>Size</span>

                <strong>
                  {{ selectedResource?.fileSize }}
                </strong>

              </div>

              <div class="dd-product-detail">

                <span>Downloads</span>

                <strong>
                  {{ selectedResource?.downloads }}
                </strong>

              </div>

            </div>

            <div class="dd-price-box">

              <span
                class="dd-modal-old-price"
                *ngIf="
                  selectedResource?.salePrice &&
                  selectedResource?.salePrice! <
                  selectedResource?.price!
                ">

                £{{ selectedResource?.price }}

              </span>

              <span class="dd-modal-price">

                £{{
                  selectedResource?.salePrice ||
                  selectedResource?.price
                }}

              </span>

            </div>

            <ul class="dd-includes-list">

              <li>
                Instant Download Access
              </li>

              <li>
                Lifetime Access
              </li>

              <li>
                Printable PDF Format
              </li>

              <li>
                Secure Payment
              </li>

              <li>
                Re-download Anytime
              </li>

            </ul>

          </div>

        </div>

        <!-- RIGHT SIDE -->
        <div class="dd-modal-right">

          <div class="dd-form-header">

            <h3>
              Complete Your Purchase
            </h3>

            <p>
              Fill in your details and proceed
              to secure payment.
            </p>

          </div>

          <form
            class="dd-form"
            (ngSubmit)="createOrder()"
            novalidate>

            <!-- FIRST NAME -->
            <div
              class="dd-form-group"
              [class.dd-error]="formErrors.firstName">

              <label>
                First Name *
              </label>

              <input
                type="text"
                [(ngModel)]="formData.firstName"
                name="firstName"
                placeholder="Enter first name">

              <span
                class="dd-error-text"
                *ngIf="formErrors.firstName">

                {{ formErrors.firstName }}

              </span>

            </div>

            <!-- LAST NAME -->
            <div
              class="dd-form-group"
              [class.dd-error]="formErrors.lastName">

              <label>
                Last Name *
              </label>

              <input
                type="text"
                [(ngModel)]="formData.lastName"
                name="lastName"
                placeholder="Enter last name">

              <span
                class="dd-error-text"
                *ngIf="formErrors.lastName">

                {{ formErrors.lastName }}

              </span>

            </div>

            <!-- EMAIL -->
            <div
              class="dd-form-group"
              [class.dd-error]="formErrors.email">

              <label>
                Email Address *
              </label>

              <input
                type="email"
                [(ngModel)]="formData.email"
                name="email"
                placeholder="Enter email address">

              <span
                class="dd-error-text"
                *ngIf="formErrors.email">

                {{ formErrors.email }}

              </span>

            </div>

            <!-- PHONE -->
            <div class="dd-form-group">

              <label>
                Phone Number
              </label>

              <input
                type="text"
                [(ngModel)]="formData.phone"
                name="phone"
                placeholder="Optional">

            </div>

            <!-- CONSENT -->
            <div class="dd-checkbox-wrap">

              <label class="dd-checkbox-label">

                <input
                  type="checkbox"
                  [(ngModel)]="formData.consent"
                  name="consent">

                <span>
                  I agree to receive useful
                  11+ preparation resources
                  and updates.
                </span>

              </label>

            </div>

            <!-- TOTAL -->
            <div class="dd-order-summary">

              <div class="dd-order-row">

                <span>
                  Resource
                </span>

                <strong>
                  £{{
                    selectedResource?.salePrice ||
                    selectedResource?.price
                  }}
                </strong>

              </div>

              <div class="dd-order-row dd-order-total">

                <span>
                  Total
                </span>

                <strong>
                  £{{
                    selectedResource?.salePrice ||
                    selectedResource?.price
                  }}
                </strong>

              </div>

            </div>

            <!-- PAY BUTTON -->
            <button
              type="submit"
              class="dd-pay-btn"
              [disabled]="isProcessingPayment">

              <span *ngIf="!isProcessingPayment">

                Pay £{{
                  selectedResource?.salePrice ||
                  selectedResource?.price
                }}

                & Download

              </span>

              <span *ngIf="isProcessingPayment">

                Redirecting To Payment...

              </span>

            </button>

            <div class="dd-payment-note">

              Secure checkout powered by
              encrypted payment gateway.

            </div>

          </form>

        </div>

      </div>

      <!-- ============================================================
           ALREADY PURCHASED TAB
           ============================================================ -->
      <div
        class="dd-existing-tab"
        *ngIf="activeTab === 'existing' && !paymentCompleted">

        <div class="dd-existing-card">

          <h2>
            Already Purchased?
          </h2>

          <p>
            Enter the email address used
            during purchase and we'll
            instantly verify your access.
          </p>

          <div class="dd-existing-form">

            <input
              type="email"
              [(ngModel)]="lookupEmail"
              placeholder="Enter your email">

            <button
              type="button"
              class="dd-check-btn"
              (click)="checkPurchase()">

              Check Purchase

            </button>

          </div>

          <!-- PURCHASE FOUND -->
          <div
            class="dd-purchase-found"
            *ngIf="purchaseFound">

            <div class="dd-found-icon">

              ✓

            </div>

            <h3>
              Purchase Found
            </h3>

            <p>
              Your resource is ready for
              download.
            </p>

            <a
              [href]="downloadUrl"
              target="_blank"
              class="dd-download-again-btn"
              (click)="trackDownload()">

              Download Resource

            </a>

          </div>

          <!-- PURCHASE NOT FOUND -->
          <div
            class="dd-purchase-not-found"
            *ngIf="
              purchaseChecked &&
              !purchaseFound
            ">

            <div class="dd-not-found-icon">

              !

            </div>

            <h3>
              No Purchase Found
            </h3>

            <p>
              We couldn't find a purchase
              associated with that email.
            </p>

            <button
              type="button"
              class="dd-switch-tab-btn"
              (click)="activeTab='purchase'">

              Purchase Resource

            </button>

          </div>

        </div>

      </div>

      <!-- ============================================================
           PAYMENT SUCCESS SCREEN
           ============================================================ -->
      <div
        class="dd-payment-success"
        *ngIf="paymentCompleted">

        <div class="dd-success-icon">

          ✓

        </div>

        <h2>
          Payment Successful
        </h2>

        <p>
          Thank you for your purchase.
          Your resource is now ready
          for download.
        </p>

        <div class="dd-success-resource">

          <div class="dd-success-title">

            {{ selectedResource?.title }}

          </div>

          <div class="dd-success-meta">

            {{ selectedResource?.fileType }}
            •
            {{ selectedResource?.fileSize }}

          </div>

        </div>

        <a
          [href]="downloadUrl"
          target="_blank"
          class="dd-final-download-btn"
          (click)="trackDownload()">

          Download Now

        </a>

        <p class="dd-success-email">

          A copy of your purchase
          has been linked to

          <strong>
            {{ formData.email }}
          </strong>

        </p>

        <button
          class="dd-close-success-btn"
          (click)="closeModal()">

          Continue Browsing

        </button>

      </div>

    </div>
  </div>

    <!-- ============================================================
       FAQ SECTION
       ============================================================ -->
  <section class="dd-faq-section">

    <div class="dd-container">

      <div class="dd-section-heading">

        <span class="dd-section-tag">
          FAQ
        </span>

        <h2 class="dd-section-title">
          Frequently Asked Questions
        </h2>

        <p class="dd-section-subtitle">
          Everything you need to know about purchasing
          and accessing digital resources.
        </p>

      </div>

      <div class="dd-faq-grid">

        <div class="dd-faq-card">

          <h3>
            How will I receive my files?
          </h3>

          <p>
            Immediately after successful payment,
            the download button becomes available.
            You can download your files instantly.
          </p>

        </div>

        <div class="dd-faq-card">

          <h3>
            Can I download again later?
          </h3>

          <p>
            Yes. Use the "Already Purchased"
            tab and enter the same email used
            during purchase to regain access.
          </p>

        </div>

        <div class="dd-faq-card">

          <h3>
            Is there an expiry date?
          </h3>

          <p>
            No. Your purchase includes
            lifetime access to the resource.
          </p>

        </div>

        <div class="dd-faq-card">

          <h3>
            Are these resources printable?
          </h3>

          <p>
            Yes. All downloads are supplied
            in high-quality PDF format and
            can be printed as many times
            as required.
          </p>

        </div>

        <div class="dd-faq-card">

          <h3>
            Can I access from multiple devices?
          </h3>

          <p>
            Yes. You may download and use
            the resource on any of your devices.
          </p>

        </div>

        <div class="dd-faq-card">

          <h3>
            Are the materials updated?
          </h3>

          <p>
            We regularly review and update
            our resources to align with
            current 11+ exam requirements.
          </p>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       TRUST SECTION
       ============================================================ -->
  <section class="dd-trust-section">

    <div class="dd-container">

      <div class="dd-trust-grid">

        <div class="dd-trust-item">

          <div class="dd-trust-number">
            15,000+
          </div>

          <div class="dd-trust-label">
            Resource Downloads
          </div>

        </div>

        <div class="dd-trust-item">

          <div class="dd-trust-number">
            98%
          </div>

          <div class="dd-trust-label">
            Parent Satisfaction
          </div>

        </div>

        <div class="dd-trust-item">

          <div class="dd-trust-number">
            500+
          </div>

          <div class="dd-trust-label">
            Practice Papers
          </div>

        </div>

        <div class="dd-trust-item">

          <div class="dd-trust-number">
            11+
          </div>

          <div class="dd-trust-label">
            Exam Specialists
          </div>

        </div>

      </div>

    </div>

  </section>

  <!-- ============================================================
       FINAL CTA
       ============================================================ -->
  <section class="dd-cta-section">

    <div class="dd-container">

      <div class="dd-cta-card">

        <div class="dd-cta-content">

          <span class="dd-cta-tag">
            Need More Support?
          </span>

          <h2 class="dd-cta-title">

            Looking For Full 11+ Preparation?

          </h2>

          <p class="dd-cta-subtitle">

            Join hundreds of families already
            preparing with Sehyog Academy through
            expert tutoring, mock exams and
            personalised guidance.

          </p>

        </div>

        <div class="dd-cta-actions">

          <a
            routerLink="/freedemo"
            class="dd-cta-btn">

            Book Free Demo

            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none">

              <path
                d="M5 12H19"
                stroke="currentColor"
                stroke-width="2">
              </path>

              <path
                d="M12 5L19 12L12 19"
                stroke="currentColor"
                stroke-width="2">
              </path>

            </svg>

          </a>

        </div>

      </div>

    </div>

  </section>

</div>